const scrollableSidebar = document.querySelector('.js-check-suites-sidebar') as HTMLElement

/**
 * The .js-check-suites-sidebar element is used for both the old check runs
 * views as well as the actions jobs view. In both cases they need JS to calc
 * the height of their containers.
 */
function calculateSidebarHeight() {
  if (!scrollableSidebar) return
  scrollableSidebar.style.height = `${window.innerHeight - scrollableSidebar.getBoundingClientRect().top}px`

  const sidebarParent = scrollableSidebar.parentElement
  if (!sidebarParent) return
  if (sidebarParent.getBoundingClientRect().height > scrollableSidebar.getBoundingClientRect().height) {
    // grow to the sidebar parent's height when the parent overflows outside the window
    // this happens when hitting the min-height on .js-full-logs-container on actions-centric pages
    scrollableSidebar.style.height = `${sidebarParent.getBoundingClientRect().height}px`
  }
}
calculateSidebarHeight()

/* eslint-disable-next-line github/prefer-observers */
window.addEventListener('resize', calculateSidebarHeight)
